import MetadataManager from './MetadataManager';

const KEY = 'sequence_number';

/**
 * Class for handling logic related to the sequence number.
 */
export default class SequenceNumberHandler {
	/**
	 * Get the current sequence number.
	 *
	 * @returns The current sequence number.
	 */
	public getSequenceNumber(): number {
		const metadata = MetadataManager.getApplicationMetadata();
		return metadata?.applicationId
			? Number(sessionStorage.getItem(metadata.applicationId.concat('_', KEY)))
			: 0;
	}

	/**
	 * Reset sequence number to the default value.
	 */
	public resetSequenceNumber(): void {
		this.setSequenceNumber(0);
	}

	/**
	 * Increment the current sequence number.
	 */
	public incrementSequenceNumber(): void {
		const value = this.getSequenceNumber();
		const updateValue = value + 1;
		this.setSequenceNumber(updateValue);
	}

	/**
	 * Set the sequence number.
	 *
	 * @param value Sequence number to store.
	 */
	private setSequenceNumber(value: number): void {
		const metadata = MetadataManager.getApplicationMetadata();
		if (metadata?.applicationId) {
			sessionStorage.setItem(metadata.applicationId.concat('_', KEY), String(value));
		}
	}
}
